import 'bootstrap/dist/css/bootstrap.min.css'
import { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import LoaderBox from './Components/LoaderBox/LoaderBox'
import './globals'
import * as serviceWorker from './serviceWorker'
import './Style/styles.scss'

const App = lazy(() => import('./App'))

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <Suspense fallback={<LoaderBox loader />}>
    <App />
  </Suspense>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
